import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    constructor(private http: HttpClient) { }

    getInit() {
        return this.http.get(`${environment.apiUrl}api/user-ip/`)
    }

    getVerifyGstin(gst_number, isBooking = false) {
        return this.http.get(`${environment.apiUrl}verify_gstin/?gst_number=${gst_number}&is_booking=${isBooking}`)
    }
    getVerifyPan(pan_number) {
        return this.http.get(`${environment.apiUrl}verify_pan/?pan_number=${pan_number}`)
    }
    getAllCountry(): Observable<any> {
        return this.http.get(`${environment.apiUrl}lookup_country_get`);
    }
    getStateAgainstCountry() {
        return this.http.get(`assets/json/state-list.json`);
    }
    checkIsUserExist(params) {
        return this.http.get(
            `${environment.apiUrl}user/exist/check`, { params }
        );
    }

    generatePDF(data: any) {
        return this.http.post(`${environment.flightApi}common/generate-pdf`, data, { responseType: 'blob' });
    }

    getHomeBanner(module) {
        return this.http.get(
            `${environment.apiUrl}retrieve/platform/cms/?module=${module}`
        );
    }

    paymentStatus(paymentStatusRequest) {
        return this.http.post(`${environment.flightApi}common/payment-status`, paymentStatusRequest)
    }

    /**
     * Saved-traveller search. `ageMin` / `ageMax` are whole years on
     * `travelDate` and override the product's own age brackets on the
     * endpoint — for a product like ferry whose brackets it does not know.
     * Zero is a real bound (an infant is 0–2), hence the null checks.
     */
    getPassengersList<T = any>(
        search: string, type?: string, product?: string, travelDate?: string,
        ageMin?: number | null, ageMax?: number | null,
    ): Observable<T> {
        let url = `${environment.apiUrl}passenger/details/list`
            + `?name=${encodeURIComponent(search ?? '')}`;
        if (type) {
            url += `&type=${encodeURIComponent(type)}`;
        }
        if (product) {
            url += `&product=${encodeURIComponent(product)}`;
        }
        if (travelDate) {
            url += `&travel_date=${encodeURIComponent(travelDate)}`;
        }
        if (ageMin != null) {
            url += `&age_min=${encodeURIComponent(String(ageMin))}`;
        }
        if (ageMax != null) {
            url += `&age_max=${encodeURIComponent(String(ageMax))}`;
        }
        return this.http.get<T>(url);
    }
}
//api/user-ip/